import {
  BlockedCustomerRequestInterface,
  UnblockedCustomerRequestInterface
} from "../contracts/ManageCustomer";

export class BlockedCustomerRequest implements BlockedCustomerRequestInterface {
  private reason: string

  constructor(reason: string) {
    this.reason = reason
  }

  public toPayload(): string {
    return JSON.stringify({
      reason: this.reason,
    })
  }
}

export class UnblockedCustomerRequest implements UnblockedCustomerRequestInterface {
  private reason: string

  constructor(reason: string) {
    this.reason = reason
  }

  public toPayload(): string {
    return JSON.stringify({
      reason: this.reason,
    })
  }
}
